import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OrganizationsClient } from "../../web-api-client";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { appConfig } from "../../appconfig";

export function useDeleteOrganization() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (id: number) => {
      const client = new OrganizationsClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });
      return client.deleteApiOrganizations(id);
    },
    onSuccess: (_result, id) => {
      queryClient.invalidateQueries({ queryKey: ["organizations"] });
      queryClient.invalidateQueries({ queryKey: ["organizations", id] });
    },
  });
}